import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import CustomButton from '../../customButton';
import SelectField from '../../selectField';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';
import { sticky } from '../../../../constants/helperCssRules';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: '220px 1fr',
      gridColumnGap: 8,
      paddingBottom: spacing(6),
      paddingTop: spacing(3),
      [breakpoints.up('xl')]: {
        gridTemplateColumns: '298px 1fr',
      },
      ...sticky(primary.white, 159, 99),
    },
    actionsWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    todayButton: {
      alignSelf: 'end',
    },
    intervalWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: 24,
    },
    intervalSelection: {
      minWidth: 110,
    },
    periodButtonsWrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridColumnGap: 4,
    },
    arrowButton: {
      height: 40,
      width: 40,
      alignSelf: 'end',
    },
    arrowButtonRight: {
      transform: 'rotate(180deg)',
    },
    arrowButtonIcon: {
      height: 16,
      width: 12,
    },
  })
);

const Actions = ({
  translations,
  selectedInterval,
  intervalOptions,
  onSetCurrentdate,
  onChangeInterval,
  onNextPeriod,
  onPreviousPeriod,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div />
      <div className={classes.actionsWrapper}>
        <CustomButton
          className={classes.todayButton}
          type="darkRounded"
          onClick={onSetCurrentdate}
        >
          {translations.today}
        </CustomButton>
        <div className={classes.intervalWrapper}>
          <Typography variant="body2">{translations.intervalLabel}</Typography>
          <SelectField
            className={classes.intervalSelection}
            value={selectedInterval}
            options={intervalOptions}
            onChange={onChangeInterval}
            isValueHighlighted
            isSearchDisabled
            shouldRemoveLabel
          />
          <div className={classes.periodButtonsWrapper}>
            <ActionButton
              className={classes.arrowButton}
              iconClass={classes.arrowButtonIcon}
              type={ACTION_BUTTON_TYPES.ARROW_LEFT}
              onClickHandler={onPreviousPeriod}
            />
            <ActionButton
              className={classNames(
                classes.arrowButton,
                classes.arrowButtonRight
              )}
              iconClass={classes.arrowButtonIcon}
              type={ACTION_BUTTON_TYPES.ARROW_LEFT}
              onClickHandler={onNextPeriod}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Actions.propTypes = {
  translations: PropTypes.object.isRequired,
  intervalOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedInterval: PropTypes.string.isRequired,
  onSetCurrentdate: PropTypes.func.isRequired,
  onChangeInterval: PropTypes.func.isRequired,
  onNextPeriod: PropTypes.func.isRequired,
  onPreviousPeriod: PropTypes.func.isRequired,
};

export default Actions;
